<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ["data", "options", "chartData"],
    watch: {
        // Updating the chart properties here due to the lineBeforeIndex
        // value not updating properly when changing the range of the chart
        chartData: function() {
            this.$data._chart.data = this.chartData;
            this.$data._chart.update();
        },
        options: function() {
            this.$data._chart.options = this.options;
            this.$data._chart.update();
        },
    },
    mounted() {
        Chart.defaults.global.defaultFontSize = 12;
        Chart.defaults.global.elements.line.tension = 0;

        this.addPlugin({
            id: "line-plugin",
            getLinePosition: function(chartInstance, pointIndex) {
                const meta = chartInstance.getDatasetMeta(0); // first dataset is used to discover X coordinate of a point
                const data = meta.data;
                return data[pointIndex]._model.x;
            },
            renderVerticalLine: function(chartInstance, pointIndex) {
                const beforeOffset = this.getLinePosition(chartInstance, pointIndex - 1);
                const afterOffset = this.getLinePosition(chartInstance, pointIndex);
                const lineLeftOffset = (beforeOffset + afterOffset) / 2;
                const scale = chartInstance.scales["y-axis-0"];
                const context = chartInstance.chart.ctx;

                // render vertical line
                context.beginPath();
                context.strokeStyle = "#000000";
                context.moveTo(lineLeftOffset, scale.top);
                context.lineTo(lineLeftOffset, scale.bottom);
                context.stroke();

                // write label
                // context.fillStyle = "#ff0000";
                // context.textAlign = 'center';
                // context.font = 'bold 12px "Helvetica Neue", Helvetica, Arial, sans-serif';
                // context.fillText('MY TEXT', lineLeftOffset, (scale.bottom - scale.top) / 2 + scale.top);
            },
            renderPhaseChangeLine: function(chartInstance, pointIndex) {
                const lineLeftOffset = this.getLinePosition(chartInstance, pointIndex);
                const labelOffset = lineLeftOffset - 15;
                const yScale = chartInstance.scales["y-axis-0"];
                const xScale = chartInstance.scales["x-axis-0"];
                const context = chartInstance.chart.ctx;

                // render vertical line
                context.beginPath();
                context.strokeStyle = "#000000";
                context.moveTo(lineLeftOffset, yScale.top);
                context.lineTo(lineLeftOffset, yScale.bottom);
                context.stroke();

                // write label
                context.fillStyle = "#ff0000";
                context.textAlign = "center";
                context.font = 'bold 12px "Helvetica Neue", Helvetica, Arial, sans-serif';
                context.fillText(
                    chartInstance.data.labels[pointIndex],
                    labelOffset,
                    yScale.top + 15
                );
            },
            //Using afterRender so it only runs once instead of running for the length of the dataset.
            afterRender: function(chartInstance) {
                if (chartInstance.options.lineBeforeIndex) {
                    chartInstance.options.lineBeforeIndex.forEach(pointIndex => {
                        if (pointIndex === 1) {
                            return this.renderVerticalLine(chartInstance, pointIndex);
                        }
                        if (pointIndex > 1) {
                            return this.renderPhaseChangeLine(chartInstance, pointIndex);
                        }
                    });
                }
            },
        });

        this.renderChart(this.data, this.options);
    },
};
</script>
